import React, {useContext, useEffect, useState} from "react";
import {FaBars} from "react-icons/fa";
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  NavMenu,
  SubItem,
  SubLinks,
  SubMenu
} from "./NavbarElements";
import {SocialFollowWhite} from "../../../components/SocialFollow";
import "./navbar.css";
import logo from "../../../assets/Images/Main-Logo.png"

import {CategoryContext} from "../index";
import {useScrollDirection} from "../../../components/scrollDirectionHook";


const Navbar = ({toggle}) => {
  const scrollDirection = useScrollDirection();
  const [isLogin, setIsLogin] = useState("login");
  const [categories, setCategories] = useState([]);

  const CategoryObj = useContext(CategoryContext);


  useEffect(() => {
    if (localStorage.getItem("token")) {
      setIsLogin("Logout");
    }
  }, []);
  const clickLogin = () => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      setIsLogin("login");
    }
  };

  return (
    <div className={`header-nav ${
      scrollDirection === "down"
        ? "hide"
        : "show"
    }`}>
      <Nav>
        <NavbarContainer>
          <NavLogo to="/">
            <img src={logo} alt="Pop BeLLy" className="logo"/>
          </NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars/>
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks to="/">Home</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="#">NFTs</NavLinks>
              <SubMenu>
                <SubItem>
                  <SubLinks to="/allnfts">All NFTs</SubLinks>
                </SubItem>
                <SubItem>
                  <SubLinks to="/3D-Animations">3D Animations</SubLinks>
                </SubItem>
                <SubItem>
                  <SubLinks to="/Bedrooms">Bedrooms</SubLinks>
                </SubItem>
                <SubItem>
                  <SubLinks to="/Mancaves">Mancaves</SubLinks>
                </SubItem>
                <SubItem>
                  <SubLinks to="/People">People</SubLinks>
                </SubItem>
              </SubMenu>
            </NavItem>

            <NavItem>
              <NavLinks to="/about">About</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/roadmap">Roadmap</NavLinks>
            </NavItem>

            <SocialFollowWhite/>
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </div>
  );
};

export default Navbar;
